import Button from 'components/form/Button';
import SeachInput from 'components/form/SeachInput';
import Card from 'components/Layout/Card';
import Loader from 'components/Layout/Loader';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { icons } from 'utils/constants';
import AddManualFollowUpPopup from '../AddManualFollowUpPopup';
import CheckBox from 'components/form/CheckBox';
import Profile from 'components/Layout/Profile';
import { Accordion, Pagination } from 'react-bootstrap';
import '../FollowUpData/ManualFollowUpData.scss';
import CouponPopup from './CouponPopup';
import PreviewPopup from './PreviewPopup';

const FollowUpUserDetails = ({ userDataList, followupsName }) => {
  const [userList, setUserList] = useState(userDataList);
  const [selectAll, setSelectAll] = useState(false);
  const [openCouponPopup, setOpenCouponPopup] = useState(false);
  const { userDetails } = useSelector((state) => ({
    userDetails: state.student.userDetails,
  }));

  const [userAbstractIds, setUserAbstractIds] = useState(null);
  const { create: createAccess, update: updateAccess } =
    userDetails?.role_data?.find(
      (item) => item?.permission_name === 'FollowUp-Discount'
    )?.sub_permission || {};

  const handleSelectAll = () => {
    const newSelectAll = !selectAll;
    setSelectAll(newSelectAll);

    setUserList((prev) =>
      prev?.map((user) => ({
        ...user,
        is_checked: newSelectAll ? 1 : 0,
      }))
    );
  };

  const handleSingleCheck = (id) => {
    setUserList((prev) => {
      const updatedUsers = prev?.map((user) =>
        user?.id === id
          ? { ...user, is_checked: user?.is_checked ? 0 : 1 }
          : user
      );
      const allSelected = updatedUsers?.every((user) => user?.is_checked === 1);
      setSelectAll(allSelected);
      return updatedUsers;
    });
  };

  const handleProceedToNext = () => {
    const selectedUsersIds = userList
      ?.filter((o) => o?.is_checked === 1)
      ?.map((o) => o?.id);
    const abstractIds = selectedUsersIds?.join(',');
    setUserAbstractIds(abstractIds);
    setOpenCouponPopup(true);
  };

  const isProceedBtn = userList?.some(
    (o) => o?.is_checked === 1
  );

  return (
    <>
      {openCouponPopup && (
        <PreviewPopup
          onHide={() => {
            setOpenCouponPopup(false);
            setUserAbstractIds(null);
          }}
          followupsName={followupsName}
          userAbstractIds={userAbstractIds}
        />
      )}
      {/* <CouponPopup onHide={() => setOpenCouponPopup(false)} /> */}
      <div className="row">
        <div className="cmb-14 d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center gap-3">
            {userList?.length !== 0 && (
              <>
                <div
                  className="all-user-check d-flex align-items-center"
                  onClick={() => {
                    handleSelectAll();
                  }}
                >
                  <div className="me-2">
                    <CheckBox
                      type="PRIMARY-ACTIVE"
                      onClick={() => {}}
                      isChecked={selectAll}
                    />
                  </div>
                  <div className="text-14-400-18 color-black-olive">
                    Select All Users
                  </div>
                </div>

                {isProceedBtn && (
                  <div className="d-flex">
                    <Button
                      text={'Proceed Next'}
                      className={'h-35 cps-15 cpe-15'}
                      btnStyle={'primary-dark'}
                      onClick={handleProceedToNext}
                    />
                  </div>
                )}
              </>
            )}
          </div>
        </div>

        {userList?.map((elem, index) => {
          return (
            <div className="col-md-6 col-lg-6 col-xl-4 cmb-14" key={index}>
              <div className="cps-14 cpt-16 cpe-14 cpb-14 follow-up-detail-border position-relative d-flex  gap-3">
                <div className="position-absolute right-25 top-25 pointer">
                  <CheckBox
                    type="PRIMARY-ACTIVE"
                    onClick={() => {
                      handleSingleCheck(elem?.id);
                    }}
                    isChecked={!!elem.is_checked}
                  />
                </div>
                <div className="">
                  <Profile
                    text={elem?.name}
                    url={elem?.profile_photo}
                    size="s-134"
                    isS3UserURL
                  />
                </div>
                <div className="width-60">
                  <div className="text-14-400-18 color-48c0 cmb-15">
                    {elem?.name}
                  </div>
                  <div className="text-10-400-18 color-6866 d-flex align-items-center text-break gap-2 cmb-15">
                    <i className="bi bi-envelope" />
                    {elem?.email}
                  </div>

                  <div className="text-14-400-18 color-6866 d-flex align-items-center gap-2">
                    <i className="bi bi-telephone" /> {elem?.phone_number}
                  </div>
                </div>
              </div>
            </div>
          );
        })}
        {/* {totalPage > 1 && (
        <div className="d-flex align-items-center justify-content-between flex-wrap footer-block">
          <div className="d-flex gap-4 cmt-30 cpb-30">
            <Button
              icon={<i className="bi bi-chevron-left me-1" />}
              text="Previous"
              btnStyle={activePage === 1 ? 'primary-gray' : 'primary-dark'}
              className="cps-20 cpe-20"
              onClick={() => {
                if (activePage !== 1) {
                  handlePagination(filterData?.offset - filterData?.limit);
                }
              }}
              isRounded
            />
            <Button
              rightIcon={<i className="bi bi-chevron-right ms-2" />}
              text="Next"
              btnStyle={
                activePage === totalPage ? 'primary-gray' : 'primary-dark'
              }
              className="cps-40 cpe-30"
              onClick={() => {
                if (activePage !== totalPage) {
                  handlePagination(filterData?.offset + filterData?.limit);
                }
              }}
              isRounded
            />
          </div>

          <div className="d-flex align-items-center ">
            <Pagination className="d-flex align-items-center unset-m">
              <div className="text-16-400 color-davys-gray me-1">Page</div>
              <Pagination.Item disabled>{activePage}</Pagination.Item>
              <div className="text-16-400 color-davys-gray ms-1 me-2">of</div>
              <Pagination.Item disabled>{totalPage}</Pagination.Item>
            </Pagination>
          </div>
        </div>
      )} */}
      </div>
    </>
  );
};

export default FollowUpUserDetails;
